import { useState } from 'react'
import { Tooltip } from 'antd'
import { CopyOutlined, CheckOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons'
import { showMessageError, showMessageSuccess } from 'src/helpers/functions'
import { copyToClipboard } from './copyToClipboard'

/**
 * O hien thi key trong bang. Mac dinh che bot, admin bam mat de xem day du
 * hoac bam icon copy de sao chep ngay ma khong can hien ra man hinh.
 */
const KeyCell = (props: any) => {
   const { apiKey, prefix } = props
   const [revealed, setRevealed] = useState(false)
   const [copied, setCopied] = useState(false)

   // Key tao truoc khi bat tinh nang luu ban ma hoa -> khong xem lai duoc
   if (!apiKey) {
      return (
         <Tooltip title={'Key này được tạo trước khi hệ thống hỗ trợ xem lại nên không hiển thị được. Hãy tạo key mới nếu cần.'}>
            <span style={{ color: '#999' }}>{`zd_${prefix}_••••••`}</span>
         </Tooltip>
      )
   }

   const handleCopy = async () => {
      const ok = await copyToClipboard(apiKey)
      if (ok) {
         setCopied(true)
         showMessageSuccess('Đã sao chép API key')
         setTimeout(() => setCopied(false), 2000)
      } else {
         showMessageError('Không sao chép được, vui lòng bấm hiện key rồi copy thủ công')
      }
   }

   return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
         <span
            style={{
               fontFamily: 'monospace',
               wordBreak: 'break-all',
               flex: 1,
               userSelect: revealed ? 'all' : 'none'
            }}
         >
            {revealed ? apiKey : `zd_${prefix}_••••••`}
         </span>

         <Tooltip title={revealed ? 'Ẩn key' : 'Hiện key'}>
            <span className="gx-pointer gx-link" onClick={() => setRevealed(!revealed)}>
               {revealed ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            </span>
         </Tooltip>

         <Tooltip title={copied ? 'Đã sao chép' : 'Sao chép key'}>
            <span className="gx-pointer gx-link" onClick={handleCopy}>
               {copied ? <CheckOutlined style={{ color: '#52c41a' }} /> : <CopyOutlined />}
            </span>
         </Tooltip>
      </div>
   )
}

export default KeyCell
